"use strict";
/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = require("three");
const SolidLineMaterial_1 = require("./SolidLineMaterial");
/**
 * Material designed to render dashed variable-width lines.
 */
class DashedLineMaterial extends SolidLineMaterial_1.SolidLineMaterial {
    /**
     * Constructs a new `DashedLineMaterial`.
     *
     * @param params `DashedLineMaterial` parameters.
     */
    constructor(params) {
        const shaderParams = {};
        if (params !== undefined && params.color !== undefined) {
            shaderParams.color = params.color;
        }
        if (params !== undefined && params.outlineColor !== undefined) {
            shaderParams.outlineColor = params.outlineColor;
        }
        if (params !== undefined && params.lineWidth !== undefined) {
            shaderParams.lineWidth = params.lineWidth;
        }
        if (params !== undefined && params.outlineWidth !== undefined) {
            shaderParams.outlineWidth = params.outlineWidth;
        }
        if (params !== undefined && params.opacity !== undefined) {
            shaderParams.opacity = params.opacity;
        }
        if (params !== undefined && params.fog !== undefined) {
            shaderParams.fog = params.fog;
        }
        super(shaderParams);
        this.name = "DashedLineMaterial";
        Object.assign(this.uniforms, {
            dashSize: new THREE.Uniform(DashedLineMaterial.DEFAULT_DASH_SIZE),
            gapSize: new THREE.Uniform(DashedLineMaterial.DEFAULT_GAP_SIZE)
        });
        // Apply initial parameter values.
        if (params !== undefined) {
            if (params.dashSize !== undefined) {
                this.dashSize = params.dashSize;
            }
            if (params.gapSize !== undefined) {
                this.gapSize = params.gapSize;
            }
            if (params.fog !== undefined) {
                this.fog = params.fog !== null;
            }
            if (params.dashColor === undefined) {
                this.dashTransparency = true;
            }
            else {
                this.dashColor.set(params.dashColor);
                this.dashColor = this.dashColor; // Trigger setter
            }
        }
    }
    /**
     * Dashes color.
     */
    get dashColor() {
        return this.uniforms.dashColor.value;
    }
    set dashColor(value) {
        this.uniforms.dashColor.value = value;
        this.dashTransparency = false;
    }
    get dashTransparency() {
        return !this.defines.USE_DASH_COLOR;
    }
    set dashTransparency(value) {
        this.defines.USE_DASH_COLOR = value ? 0 : 1;
    }
    /**
     * Size of the dashed segments.
     */
    get dashSize() {
        return this.uniforms.dashSize.value;
    }
    set dashSize(value) {
        this.uniforms.dashSize.value = value;
    }
    /**
     * Size of the gaps between dashed segments.
     */
    get gapSize() {
        return this.uniforms.gapSize.value;
    }
    set gapSize(value) {
        this.uniforms.gapSize.value = value;
        this.updateDashedFeature();
    }
    updateDashedFeature() {
        this.defines.DASHED_LINE = this.gapSize > 0.0 ? 1 : 0;
    }
}
exports.DashedLineMaterial = DashedLineMaterial;
DashedLineMaterial.DEFAULT_DASH_SIZE = 1.0;
DashedLineMaterial.DEFAULT_GAP_SIZE = 1.0;
